module.exports = __webpack_public_path__ + "media/images/upload_1-66662c0b.png";